import { renderRichText } from 'gatsby-source-contentful/rich-text'
import React from 'react'
import { FeatureListProps } from '../types'
import { classNames } from '../utils'

export const FeatureList = ({
  title,
  features,
  svg,
  svgTitle,
}: FeatureListProps) => {
  return (
    <div className="mb-32 flex flex-col items-center md:mb-2">
      <object
        className="w-full sm:hidden"
        type="image/svg+xml"
        data={svg}
        title={svgTitle}
      />
      <h3
        className={classNames(
          'rounded-3xl bg-default-200/10 px-[17px] pb-[5px] pt-[6px] text-center text-xl font-medium text-default-50'
        )}
      >
        {title}
      </h3>
      <div className="feature-ul">{renderRichText(features)}</div>
    </div>
  )
}
